<template>
  <div class="contact-page">
    <!-- 页面顶部横幅 -->
    <div class="page-banner">
      <div class="container banner-inner">
        <h1 class="banner-title">{{ $t('m.contactUs') }}</h1>
        <el-breadcrumb separator="/" class="banner-breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('m.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('m.contactUs') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="container page-content">
      <!-- 联系信息卡片 -->
      <div class="contact-cards">
        <div class="contact-card">
          <div class="contact-card-icon">
            <img src="../assets/imgs/home/address.png" :alt="$t('m.address')">
          </div>
          <h3 class="contact-card-title">{{ $t('m.companyAddress') }}</h3>
          <p class="contact-card-text">{{ address }}</p>
        </div>
        <div class="contact-card">
          <div class="contact-card-icon">
            <img src="../assets/imgs/home/phone.png" :alt="$t('m.phone')">
          </div>
          <h3 class="contact-card-title">{{ $t('m.hotline') }}</h3>
          <p class="contact-card-text">{{ phone }}</p>
        </div>
        <div class="contact-card">
          <div class="contact-card-icon">
            <img src="../assets/imgs/home/emil.png" :alt="$t('m.email')">
          </div>
          <h3 class="contact-card-title">{{ $t('m.email') }}</h3>
          <p class="contact-card-text">{{ email }}</p>
        </div>
        <div class="contact-card">
          <div class="contact-card-icon">
            <img src="../assets/imgs/home/notict_square.png" :alt="$t('m.workTime')">
          </div>
          <h3 class="contact-card-title">{{ $t('m.workTime') }}</h3>
          <p class="contact-card-text">{{ workTime }}</p>
        </div>
      </div>

      <!-- 联系我们富文本内容 -->
      <div class="contact-content" v-if="html">
        <div class="content-body" v-html="html"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { CONFIG_INDEX, getConfigValue as getCfg, formatRichText } from "../utils/site";

export default {
  name: 'ContactUs',
  data() {
    return {
      html: '',
      info: null,
      email: '',
      workTime: ''
    }
  },
  computed: {
    address() {
      return this.getConfigValue(this.info, CONFIG_INDEX.ADDRESS, this.$t('m.defaultAddress'))
    },
    phone() {
      return this.getConfigValue(this.info, CONFIG_INDEX.PHONE, this.$t('m.defaultPhone'))
    }
  },
  created() {
    this.email = this.$t('m.defaultEmail')
    this.workTime = this.$t('m.defaultWorkTime')
    this.getAbout()
  },
  methods: {
    // 安全读取站点配置，后台配置条数变化时不会白屏
    getConfigValue(config, index, fallback) {
      return getCfg(config, index, fallback)
    },
    getAbout() {
      this.$api.home.getAbout({}).then(res => {
        if (!res || !res.data) return
        const config = res.data.config
        this.info = config
        // 邮箱、工作时间，取不到保留默认文案
        this.email = this.getConfigValue(config, CONFIG_INDEX.EMAIL, this.$t('m.defaultEmail'))
        this.workTime = this.getConfigValue(config, CONFIG_INDEX.WORK_TIME, this.$t('m.defaultWorkTime'))
        // config[11] 存「联系我们」富文本内容
        const raw = this.getConfigValue(config, CONFIG_INDEX.CONTACT_CONTENT)
        if (!raw) return
        try {
          // 如果是 JSON 格式的友链数据，就不当作富文本显示
          const parsed = JSON.parse(raw)
          if (typeof parsed !== 'string') {
            this.html = ''
            return
          }
        } catch (e) {
          // 不是 JSON，按富文本内容处理
        }
        this.html = formatRichText(raw)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.contact-page {
  min-width: 1200px;
  background-color: var(--color-bg-light);
}

.page-banner {
  background: linear-gradient(135deg, var(--color-primary-dark) 0%, var(--color-primary) 100%);
  padding: 50px 0;
  position: relative;
  overflow: hidden;
}

.page-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.banner-inner {
  position: relative;
  z-index: 1;
}

.banner-title {
  font-size: 36px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-inverse);
  margin: 0 0 16px 0;
  letter-spacing: 4px;
}

.banner-breadcrumb {
  font-size: var(--font-size-sm);
}

.banner-breadcrumb :deep(.el-breadcrumb__inner) {
  color: rgba(255, 255, 255, 0.7);
}

.banner-breadcrumb :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
  color: var(--color-text-inverse);
  font-weight: var(--font-weight-medium);
}

.banner-breadcrumb :deep(.el-breadcrumb__separator) {
  color: rgba(255, 255, 255, 0.5);
}

.page-content {
  padding: 50px 0;
  min-height: 500px;
}

/* 联系信息卡片 */
.contact-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.contact-card {
  background-color: var(--color-bg-white);
  border-radius: var(--radius-lg);
  padding: 30px 24px;
  text-align: center;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-normal);
  border: 1px solid var(--color-border-light);
}

.contact-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-md);
  border-color: var(--color-primary-light);
}

.contact-card-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
  background-color: var(--color-primary-bg);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-card-icon img {
  width: 28px;
  height: 28px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(80%) saturate(400%) hue-rotate(80deg);
}

.contact-card-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  margin: 0 0 10px 0;
}

.contact-card-text {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: var(--line-height-normal);
}

/* 富文本内容 */
.contact-content {
  background-color: var(--color-bg-white);
  border-radius: var(--radius-lg);
  padding: 50px 60px;
  box-shadow: var(--shadow-sm);
}

.content-body {
  /* 建立 BFC：把后台富文本里的 float 图片收进正文框内。
     否则浮动图不计入父容器高度，会溢出到下方兄弟元素并把它挤窄。 */
  display: flow-root;
  font-size: var(--font-size-base);
  color: var(--color-text-regular);
  line-height: var(--line-height-relaxed);
}

.content-body :deep(p) {
  margin-bottom: 20px;
}

.content-body :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  border-radius: var(--radius-sm);
}

/* 同段多图并排：后台把多张图放进同一个 <p>（百分比宽度 + 行内布局），
   上面的 img{display:block} 会逐张拆成独立块、变成上下堆叠；
   此处用 flex 还原并排，间距交给后台的 width 控制。
   用 ~（一般兄弟）而非 +，以兼容图间夹 <br>/注释节点的情况。 */
.content-body :deep(p:has(> img ~ img)) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.content-body :deep(p:has(> img ~ img) > img) {
  margin: 20px 0;
}

.content-body :deep(h1),
.content-body :deep(h2),
.content-body :deep(h3) {
  color: var(--color-text-primary);
  margin: 30px 0 15px;
  font-weight: var(--font-weight-bold);
}

.content-body :deep(h2) {
  font-size: 22px;
  padding-left: 12px;
  border-left: 4px solid var(--color-primary);
}

.content-body :deep(ul),
.content-body :deep(ol) {
  padding-left: 24px;
  margin-bottom: 20px;
}

.content-body :deep(li) {
  margin-bottom: 8px;
}

.content-body :deep(a) {
  color: var(--color-primary);
  text-decoration: none;
}

.content-body :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.content-body :deep(th),
.content-body :deep(td) {
  border: 1px solid var(--color-border);
  padding: 12px 16px;
  text-align: left;
}

.content-body :deep(th) {
  background-color: var(--color-bg-lighter);
}
</style>
